var React = require('react');

function FileIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.71429 2C4.25963 2 3.82359 2.18061 3.5021 2.5021C3.18061 2.82359 3 3.25963 3 3.71429V12.2857C3 12.7404 3.18061 13.1764 3.5021 13.4979C3.82359 13.8194 4.25963 14 4.71429 14H11.5714C12.0261 14 12.4621 13.8194 12.7836 13.4979C13.1051 13.1764 13.2857 12.7404 13.2857 12.2857V6.03457C13.2857 5.80726 13.1953 5.58928 13.0346 5.42857L9.85714 2.25114C9.69643 2.09039 9.47845 2.00005 9.25114 2H4.71429ZM9 2.85714V5.42857C9 5.6559 9.09031 5.87392 9.25105 6.03466C9.4118 6.19541 9.62981 6.28571 9.85714 6.28571H12.4286L9 2.85714Z"}));
}

FileIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = FileIcon;

FileIcon.default = FileIcon;
